import { __decorate, __metadata } from "tslib";
import { IsUndefinable, LengthWithLVS } from '@goparrot/common';
import { ApiExtraModels, ApiProperty, ApiPropertyOptional, refs } from '@nestjs/swagger';
import { Expose, Type } from 'class-transformer';
import { IsBoolean, IsEnum, IsObject, IsOptional, IsString, ValidateNested } from 'class-validator';
import { FailedOrderStrategyEnum, VendorProviderEnum } from '../enum';
import { VendorExposeGroup } from '../interface';
import { ReadGoParrotMetadataDto } from './ReadGoParrotMetadataDto';
import { ReadSquareMetadataDto } from './ReadSquareMetadataDto';
import { ReadVendorMathDto } from './ReadVendorMathDto';
let ReadVendorDto = class ReadVendorDto {
};
__decorate([
    ApiProperty({ type: () => String, description: 'Store ID', example: 'e44acc6f-2f34-552c-92d3-x4199fb33335' }),
    LengthWithLVS(10, 50, { always: true }),
    IsString({ always: true }),
    Expose({ groups: [VendorExposeGroup.CREATE, VendorExposeGroup.READ] }),
    __metadata("design:type", String)
], ReadVendorDto.prototype, "storeId", void 0);
__decorate([
    ApiProperty({ type: () => String, description: 'Merchant ID', example: 'e44acc6f-2f34-552c-92d3-x4199fb44445' }),
    LengthWithLVS(10, 50, { always: true }),
    IsString({ always: true }),
    Expose({ groups: [VendorExposeGroup.READ] }),
    __metadata("design:type", String)
], ReadVendorDto.prototype, "merchantId", void 0);
__decorate([
    ApiProperty({ enum: VendorProviderEnum, description: 'Vendor (POS) provider', example: VendorProviderEnum.GOPARROT }),
    IsEnum(VendorProviderEnum, { always: true }),
    IsOptional({ groups: [VendorExposeGroup.PATCH] }),
    Expose({ groups: [VendorExposeGroup.CREATE, VendorExposeGroup.READ, VendorExposeGroup.PATCH] }),
    __metadata("design:type", String)
], ReadVendorDto.prototype, "provider", void 0);
__decorate([
    ApiPropertyOptional({ enum: VendorProviderEnum, description: 'Loyalty provider (default: the same as POS provider)', example: VendorProviderEnum.SQUARE }),
    IsEnum(VendorProviderEnum, { always: true }),
    IsOptional({ always: true }),
    Expose({ groups: [VendorExposeGroup.CREATE, VendorExposeGroup.READ, VendorExposeGroup.PATCH] }),
    __metadata("design:type", String)
], ReadVendorDto.prototype, "loyaltyProvider", void 0);
__decorate([
    ApiProperty({ type: () => ReadVendorMathDto }),
    Type(() => ReadVendorMathDto),
    ValidateNested({ always: true }),
    IsObject({ always: true }),
    IsOptional({ groups: [VendorExposeGroup.PATCH] }),
    Expose({ groups: [VendorExposeGroup.CREATE, VendorExposeGroup.READ, VendorExposeGroup.PATCH] }),
    __metadata("design:type", ReadVendorMathDto)
], ReadVendorDto.prototype, "math", void 0);
__decorate([
    ApiProperty({ type: () => Boolean, description: 'If true, the order will be sent to the POS', default: false }),
    IsBoolean({ always: true }),
    IsOptional({ groups: [VendorExposeGroup.CREATE, VendorExposeGroup.PATCH] }),
    Expose({ groups: [VendorExposeGroup.CREATE, VendorExposeGroup.READ, VendorExposeGroup.PATCH] }),
    __metadata("design:type", Boolean)
], ReadVendorDto.prototype, "isLiveMode", void 0);
__decorate([
    ApiPropertyOptional({ enum: FailedOrderStrategyEnum, description: 'Price discrepancy strategy', example: FailedOrderStrategyEnum.CONTINUE }),
    IsEnum(FailedOrderStrategyEnum, { always: true }),
    IsOptional({ always: true }),
    Expose({ groups: [VendorExposeGroup.CREATE, VendorExposeGroup.READ, VendorExposeGroup.PATCH] }),
    __metadata("design:type", String)
], ReadVendorDto.prototype, "priceDiscrepancyStrategy", void 0);
__decorate([
    ApiPropertyOptional({ type: () => Boolean, description: 'If true, check price discrepancy on items level', example: false }),
    IsBoolean({ always: true }),
    IsOptional({ always: true }),
    Expose({ groups: [VendorExposeGroup.CREATE, VendorExposeGroup.READ, VendorExposeGroup.PATCH] }),
    __metadata("design:type", Boolean)
], ReadVendorDto.prototype, "isItemPriceDiscrepancyEnabled", void 0);
__decorate([
    ApiPropertyOptional({ type: () => Boolean, description: 'If true, change order status for the pos system', example: false }),
    IsBoolean({ always: true }),
    IsUndefinable({ always: true }),
    Expose({ groups: [VendorExposeGroup.CREATE, VendorExposeGroup.READ, VendorExposeGroup.PATCH] }),
    __metadata("design:type", Boolean)
], ReadVendorDto.prototype, "isFulfillmentStatusSyncEnabled", void 0);
__decorate([
    ApiPropertyOptional({ type: () => Object, description: 'Notification templates' }),
    IsObject({ always: true }),
    IsOptional({ always: true }),
    Expose({ groups: [VendorExposeGroup.CREATE, VendorExposeGroup.READ, VendorExposeGroup.PATCH] }),
    __metadata("design:type", Object)
], ReadVendorDto.prototype, "notificationTemplates", void 0);
__decorate([
    ApiProperty({ oneOf: refs(ReadSquareMetadataDto, ReadGoParrotMetadataDto), type: () => Object, example: {}, description: 'Provider specific metadata' }),
    Type((opts) => {
        switch (opts?.object?.provider) {
            case VendorProviderEnum.SQUARE:
                return ReadSquareMetadataDto;
            default:
                return ReadGoParrotMetadataDto;
        }
    }),
    ValidateNested({ always: true }),
    IsObject({ always: true }),
    IsOptional({ groups: [VendorExposeGroup.PATCH] }),
    Expose({ groups: [VendorExposeGroup.CREATE, VendorExposeGroup.READ, VendorExposeGroup.PATCH] }),
    __metadata("design:type", Object)
], ReadVendorDto.prototype, "metadata", void 0);
ReadVendorDto = __decorate([
    ApiExtraModels(ReadSquareMetadataDto, ReadGoParrotMetadataDto)
], ReadVendorDto);
export { ReadVendorDto };
//# sourceMappingURL=ReadVendorDto.js.map